"use client";

import React, { useContext } from "react";
import styles from "./keyapp-landing-block.module.scss";
import GradientCursorFollower from "@/components/layout/gradient-cursor-follow/gradient-cursor-follower";
import { JumpMenuContext } from "@/providers/jump-menu.provider";
import { KeyAppPreviewCard } from "@/types/blocks.types";

type Props = {
  previewCards: KeyAppPreviewCard[];
};

const PreviewCards = ({ previewCards }: Props) => {
  const { anchorIdStates } = useContext(JumpMenuContext);

  return (
    <>
      {previewCards.map((card, index) => (
        <div
          className={styles.paragraph}
          key={card.title + index}
          onClick={() =>
            window.scrollTo({
              top: anchorIdStates[index].position,
              behavior: "smooth",
            })
          }
          role="button">
          <div className={styles.header}>{card.title}</div>
          <p>{card.paragraph}</p>
          <GradientCursorFollower />
        </div>
      ))}
    </>
  );
};

export default PreviewCards;
